// profileUserApi(MainInfo) - первая плитка профиля
//endpoints - собираются в узле createApi - уходят в стор
import { createApi, FetchBaseQueryMeta } from "@reduxjs/toolkit/query/react";
import baseQueryWithReAuth from "src/business.InterfaceLayer/store/services/utils.service/baseQueryWithReAuth";
import { RequestResponse, ServerResponse } from "./types/types";
import { ProfileUserDataModalType } from "src/old/Types/ProfileEditType";

export const profileUserApi = createApi({
	baseQuery: baseQueryWithReAuth,
	reducerPath: "profileUserApi",
	endpoints: (builder) => ({
		/////////////////////////////////////////////////////////////////////////GET - получение профиля
		getProfileUser: builder.query<RequestResponse, void>({
			query: () => ({
				url: "/profile/lk",
				method: "GET",
			}),
			transformResponse: (response: ServerResponse): RequestResponse => ({
				isErr: undefined,
				data: response.data || undefined,
			}),
		}),

		postProfileUser: builder.mutation<
			RequestResponse,
			ProfileUserDataModalType
		>({
			query: (data) => {
				const userId = localStorage.getItem("userId") || "";
				if (!userId) {
					throw new Error("User ID is not found in localStorage");
				}

				const payload = {
					firstname: data.firstname,
					surname: data.surname,
					patronymic: data.patronymic,
					nearestRepresentative: Number(data.nearestRepresentative),
					messengers: {
						whatsApp: data.messengers?.WhatsApp || "",
						telegram: data.messengers?.Telegram || "",
					},
					socialNetworks: {
						vk: data.socialNetwork?.VK || "",
						facebook: data.socialNetwork?.Facebook || "",
						instagram: data.socialNetwork?.Instagram || "",
					},
				};

				//console.log("payloadUserDataModal:", payload);

				return {
					url: `/v2/user/${userId}/profile/basic`,
					method: "PUT",
					body: JSON.stringify(payload),
					headers: {
						"Content-Type": "application/json",
					},
				};
			},

			transformResponse: (
				response: ServerResponse | null,
				meta: FetchBaseQueryMeta
			): RequestResponse => {
				const status = meta?.response?.status;
				//console.log("Response from server:", response);

				if (status === 204) {
					return { isErr: "204", data: response?.data };
				}

				if (!response || !response.data) {
					return {
						isErr: undefined,
						data: undefined,
					};
				}

				return { isErr: undefined, data: response?.data || undefined };
			},
		}),

		postProfileUserPhoto: builder.mutation<RequestResponse, FileList>({
			query: (data) => {
				const formData = new FormData();
				formData.append("photo", data[0]);

				return {
					url: "/user/photo",
					method: "POST",
					body: formData,
				};
			},
			transformResponse: (response: ServerResponse) => ({
				isErr: undefined,
				data: response.data || undefined,
			}),
		}),
	}),
});

export const {
	useGetProfileUserQuery,

	usePostProfileUserMutation,
	usePostProfileUserPhotoMutation,
} = profileUserApi;
